import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from "react";
import { getLastPartOfUrl } from "utils/url";
import { getSolutionCategoryPageLink } from "template-store/services/solution-links-service";
import classnames from "classnames";
import Favorite from "monday-ui-react-core/dist/icons/Favorite";
import { StyledCustomSelect } from "./custom-select.scss";
import PictureComponent from "/components/core/picture/picture-component";
const HOME_OPTION_VALUE = "home";
const HOME_OPTION_URL_VALUE = "/templates";
const FEATURED_TITLE = "Featured";
const DOWN_ARROW_ICON = "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/chevron-down-template-center-v2.png";
const CustomSelect = ({ options = [] })=>{
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    const [isWithBorder, setIsWithBorder] = useState(false);
    const selectRef = useRef(null); // Reference to the select element
    const selectedOptionRef = useRef(null); // Reference to the selected option element
    const toggleOpen = ()=>{
        if (!isOpen) {
            setIsWithBorder(true);
        }
        setIsOpen(!isOpen);
    };
    useEffect(()=>{
        const onPopUpClose = ()=>{
            if (isOpen) {
                setIsOpen(false);
            }
        };
        const checkIfClickedOutside = (e)=>{
            if (selectedOptionRef.current && !selectedOptionRef.current.contains(e.target)) {
                onPopUpClose();
                setIsWithBorder(false);
            }
        };
        document.addEventListener("click", checkIfClickedOutside);
        return ()=>{
            document.removeEventListener("click", checkIfClickedOutside);
        };
    }, [
        isOpen
    ]);
    useEffect(()=>{
        // Get the last word from the current URL
        const lastWordFromURL = getLastPartOfUrl(window.location.pathname);
        // Check if the last word exists
        if (lastWordFromURL) {
            setSelectedOption(lastWordFromURL);
        }
    }, []);
    const getLabelByValue = (value)=>{
        const item = options.find((item)=>item.value === value);
        return item ? item.label : null;
    };
    // Function to scroll the selected option into view
    const scrollToSelected = ()=>{
        if (!selectRef.current || !isOpen) return;
        const selectedItem = selectRef.current.querySelector(`.custom-select-option[data-value="${selectedOption}"]`);
        if (selectedItem) {
            const selectedItemRect = selectedItem.getBoundingClientRect();
            const selectRect = selectRef.current.getBoundingClientRect();
            // Calculate the scroll offset needed to bring the item into view
            const scrollTop = selectedItemRect.top - selectRect.top - 100;
            // Ensure the scroll position doesn't go negative
            selectRef.current.scrollTop = Math.max(0, scrollTop);
        }
    };
    useEffect(()=>{
        if (isOpen) {
            scrollToSelected();
        }
    }, [
        isOpen,
        selectedOption
    ]); // Update scroll on open/close and selection change
    return /*#__PURE__*/ _jsxs(StyledCustomSelect, {
        className: "custom-select-container",
        ref: selectedOptionRef,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: classnames("custom-select-selection", {
                    "with-border": isWithBorder
                }),
                tabIndex: 0,
                onClick: toggleOpen,
                ref: selectRef,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "label",
                        children: [
                            selectedOption === HOME_OPTION_URL_VALUE && /*#__PURE__*/ _jsx(Favorite, {}),
                            getLabelByValue(selectedOption) || FEATURED_TITLE
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "down-arrow",
                        children: /*#__PURE__*/ _jsx(PictureComponent, {
                            src: DOWN_ARROW_ICON
                        })
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ _jsx("ul", {
                className: "custom-select-options",
                ref: selectRef,
                children: options.map((option)=>/*#__PURE__*/ _jsx("li", {
                        className: classnames("custom-select-option", {
                            "is-selected": selectedOption === option.value || selectedOption === HOME_OPTION_URL_VALUE && option.value === HOME_OPTION_VALUE
                        }),
                        "data-value": option.value,
                        children: /*#__PURE__*/ _jsxs("a", {
                            href: getSolutionCategoryPageLink(option.value),
                            children: [
                                option.value === HOME_OPTION_VALUE && /*#__PURE__*/ _jsx(Favorite, {}),
                                option.label
                            ]
                        })
                    }, option.value))
            })
        ]
    });
};
export default CustomSelect;
